"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var index_1 = __importDefault(require("./mobile/index"));
var index_2 = __importDefault(require("./pc/index"));
var ProductService = function (props) {
    var _a;
    var className = props.className, flexTitle = props.flexTitle, _b = props.style, styleConfig = _b === void 0 ? {} : _b, productList = props.productList, service = props.service, serviceTitle = props.serviceTitle, moreData = props.moreData, backgroundImage = props.backgroundImage;
    var refDom = (0, react_1.useRef)(null);
    var size = (0, ahooks_1.useSize)(refDom);
    // 获取样式的通用前缀
    var _c = (0, useConfig_1.default)(), classPrefix = _c.classPrefix, mobileWidth = _c.mobileWidth;
    var prefixClassName = "".concat(classPrefix, "-product-service");
    // 判断数据长度控制容器高度
    var dataLength = productList ? productList.length : 0;
    return (react_1.default.createElement("section", { className: (0, classnames_1.default)(className, prefixClassName), ref: refDom }, Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth ? (react_1.default.createElement(index_1.default, { flexTitle: flexTitle, serviceTitle: serviceTitle, service: service, productList: productList, moreData: moreData, backgroundImage: backgroundImage })) : (react_1.default.createElement("section", { className: "".concat(prefixClassName, "__container"), style: styleConfig },
        react_1.default.createElement("div", { className: "".concat(prefixClassName, "__children") },
            react_1.default.createElement("div", { className: "".concat(prefixClassName, "__title") }, flexTitle),
            react_1.default.createElement("section", { className: (0, classnames_1.default)("".concat(prefixClassName, "__content"), (_a = {},
                    _a["".concat(prefixClassName, "__content--maxHeight")] = dataLength >= 8,
                    _a)) },
                react_1.default.createElement(index_2.default, { productList: productList, service: service, title: serviceTitle, moreData: moreData })))))));
};
ProductService.displayName = 'ProductService';
exports.default = ProductService;
//# sourceMappingURL=ProductService.js.map